// src/data/questionData.ts
export interface Question {
    id: string;
    text: string;
  }
  
  export interface QuestionCategory {
    id: string;
    header: string;
    backgroundColor: string;
    questions: Question[];
  }
  
  const questionData: QuestionCategory[] = [
    {
      id: "how-many-people",
      header: "How many people...",
      backgroundColor: "#E4CCFF", // Light purple
      questions: [
        { id: "q1", text: "love their body" },
        { id: "q2", text: "want all salaries made public" },
        { id: "q3", text: "smile in their LinkedIn photo" },
        { id: "q4", text: "think their home is too small" },
        { id: "q5", text: "prefer silence over small talk" },
        { id: "q6", text: "don't use all their paid vacation time" },
        { id: "q8", text: "are bored at work every day" },
        { id: "q9", text: "would not drive an EV even if it was free" },
        { id: "q10", text: "get the Sunday Scaries" },
        { id: "q11", text: "would work for an AI manager" },
      ],
    },
    {
      id: "how-many-people-have",
      header: "How many people have...",
      backgroundColor: "#CBD6FF", // Light blue
      questions: [
        { id: "q13", text: "been rude to AI" },
        { id: "q14", text: "had sex in public" },
        { id: "q15", text: "looked up their neighbor's home value" },
        { id: "q16", text: "lied to their partner about finances" },
        { id: "q17", text: "googled during a virtual work meeting" },
        { id: "q18", text: 'said "I love you" without meaning it' },
      ],
    },
    {
      id: "which",
      header: "Which...",
      backgroundColor: "#BDDFFF", // Sky blue
      questions: [
        { id: "q19", text: "city has the worst tasting tap water" },
        { id: "q20", text: "emojis are most confusing" },
        { id: "q21", text: "town has the most vacation homes" },
        { id: "q22", text: "colleges produce the most CEOs" },
        { id: "q23", text: "company's workers are most burned out" },
        { id: "q26", text: "concerts are most expensive per minute" },
        { id: "q27", text: "politicians are most angry on social media" },
        { id: "q28", text: "Big Tech companies pay the most" },
        { id: "q30", text: "grocery stores have the longest lines" },
        { id: "q31", text: "music acts have the saddest fans" },
      ],
    },
    {
      id: "whats-the-most",
      header: "What's the most...",
      backgroundColor: "#B0F7FF", // Cyan
      questions: [
        { id: "q32", text: "annoying corporate jargon" },
        { id: "q33", text: "overpriced restaurant in America" },
        { id: "q34", text: "high-status car in each state" },
        { id: "q35", text: "dangerous intersection in each state" },
        { id: "q36", text: "common restaurant name in America" },
        { id: "q37", text: "harsh way to begin or end an email" },
      ],
    },
    {
      id: "what-are-the-most",
      header: "What are the most...",
      backgroundColor: "#B0F4C6", // Mint green
      questions: [
        { id: "q38", text: "cringey nicknames partners use" },
        { id: "q39", text: "searched health fears" },
        { id: "q40", text: "searched song lyrics" },
        { id: "q41", text: "hated HOA restrictions" },
        { id: "q42", text: "bizarre town names in America" },
        { id: "q43", text: "uplifting songs on Spotify" },
        { id: "q44", text: "common items on bucket lists" },
        { id: "q45", text: "underappreciated professions" },
        { id: "q46", text: "recession-proof small businesses" },
      ],
    },
    {
      id: "where",
      header: "Where...",
      backgroundColor: "#DAF4AF", // Light lime
      questions: [
        { id: "q47", text: "do parents spend the most time with their kids" },
        { id: "q48", text: "are people most sensitive to winter" },
        { id: "q49", text: "are the nastiest hotels in America" },
        { id: "q50", text: "do kids ask for the most expensive toys" },
        { id: "q51", text: "do parents give smartphones earliest" },
        { id: "q52", text: "are people most charitable" },
      ],
    },
    {
      id: "what-is-the",
      header: "What is the...",
      backgroundColor: "#EBF5B0", // Light yellow
      questions: [
        {
          id: "q53",
          text: "question people are afraid to ask in interviews",
        },
        { id: "q54", text: "fastest growing small biz sector" },
        { id: "q55", text: "most dangerous candy for your teeth" },
        { id: "q56", text: "most frustrating type of junk fee" },
      ],
    },
    {
      id: "who-is",
      header: "Who...",
      backgroundColor: "#FFE870", // Yellow
      questions: [
        { id: "q57", text: "is the smartest CEO in America" },
        { id: "q58", text: "is the nicest person on the Internet" },
        { id: "q59", text: "expects to inherit money from their parents" },
        { id: "q60", text: "has the loneliest job in America" },
      ],
    },
    {
      id: "how-often",
      header: "How often...",
      backgroundColor: "#FFD5A5", // Peach
      questions: [
        { id: "q61", text: "do people worry about gun violence" },
        { id: "q62", text: "are dating profiles fake" },
        { id: "q63", text: "do people text and drive" },
        { id: "q64", text: "do moms get alone time" },
        { id: "q65", text: "do people take mental health days" },
        { id: "q66", text: "do women encounter mansplaining" },

      ],
    },
  ];
  
  export default questionData;
  